import Image from '@components/atoms/Image'
import React, { useState } from 'react'
import Modal from '../../utils/components/molecules/Modal'

interface LensTechProps {
  heading: string
  lensImage: {
    src: string
    alt: string
  }
  description: string
  valuePropsTitle: string
  lensTechValueProps: {
    heading: string
    description: string
  }[]
}

const LensTechSection: React.FC<LensTechProps> = ({
  heading,
  lensImage,
  description,
  valuePropsTitle,
  lensTechValueProps,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }
  return (
    <div className="container pt-8">
      <div className="justify-between grid grid-cols-1 gap-x-0 gap-y-4 items-center">
        <h2 className="font-appleGaramond uppercase h2" dangerouslySetInnerHTML={{ __html: heading }}></h2>
        <div>
          {lensImage.src.includes('.mp4') ? (
            <video autoPlay={true} muted playsInline={true}>
              <source src={lensImage.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <div onClick={() => openModal()} aria-label="Open Modal to zoom Image">
            <Image
              src={lensImage.src}
              alt={lensImage.alt}
              srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280 }}
              classes="w-full h-auto object-contain"
            />
            </div>
          )}
        </div>

        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <div className="relative rounded-b-lg pdp-gallery-modal mac-scroll cursor-zoom-out bg-white mt-5 max-w-3xl w-full overflow-y-auto max-h-[90vh] lg:max-w-screen-lg">
            <div className="flex flex-col gap-2">
                <div  className="w-full">
                  <Image src={lensImage.src} alt={lensImage.alt} srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }} zoomable={true} />
                </div>
            </div>
          </div>
        </Modal>

        <div className="text-black body-md" dangerouslySetInnerHTML={{ __html: description }} />

        <span
          className="text-black body-md underline underline-offset-4"
          dangerouslySetInnerHTML={{ __html: valuePropsTitle }}
        ></span>

        <div>
          {lensTechValueProps.map((block, index) => (
            <div key={index} className={`flex items-center ${index < lensTechValueProps.length - 1 ? 'pb-6' : ''}`}>
              <span dangerouslySetInnerHTML={{ __html: block.heading }}></span>
              <div className="flex items-center pl-4" dangerouslySetInnerHTML={{ __html: block.description }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default LensTechSection
